import ItemLink from './ItemLink'

const ItemAction = ItemLink.withComponent('a')

ItemAction.displayName = 'DropdownMenu.ItemAction'

export default ItemAction
